<template>
  <div class="p-1">
    <loader v-if="load"></loader>  
    <b-modal
      id="mail-send-valid"
      header-bg-variant="success"
      centered
      hide-footer
    >
      <div class="d-block">
        {{ success_message }}
      </div>
    </b-modal>
    <b-modal
      id="mail-send-not-valid"
      header-bg-variant="danger"
      centered
      hide-footer
    >
      <div class="d-block">
        {{ error_message }}
      </div>
    </b-modal>
    <div class="d-block">
      <b-form @submit.stop.prevent>
        <b-row>
          <b-col col cols="12" lg="2" md="6" class="my-1">
            <label for="lastname">Фамилия*</label>
            <b-form-input
              v-model="params.lastname"
              placeholder="Иванов"
              id="lastname"
              required
              :state="notEmpty(params.lastname)"
            ></b-form-input>
          </b-col>
          <b-col col cols="12" lg="2" md="6" class="my-1">
            <label for="firstname">Имя*</label>
            <b-form-input
              v-model="params.firstname"
              placeholder="Иван"
              id="firstname"
              required
              :state="notEmpty(params.firstname)"
            ></b-form-input>
          </b-col>
          <b-col col cols="12" lg="2" md="6" class="my-1">
            <label for="patronimic">Отчество*</label>
            <b-form-input
              v-model="params.patronimic"
              placeholder="Иванович"
              id="patronimic"
              required
              :state="notEmpty(params.patronimic)"
            ></b-form-input>
          </b-col>
          <b-col col cols="12" lg="3" md="6" class="my-1">
            <label for="phone">Номер телефона*</label>
            <b-form-input
              v-model="params.phone"
              v-mask="'+7 (###) ###-##-##'"
              placeholder="+7 (###) ###-##-##"
              id="phone"
              required
              :state="validPhone(params.phone)"
            ></b-form-input>
          </b-col>
          <b-col col cols="12" lg="3" md="6" class="my-1">
            <label for="e-mail">E-mail*</label>
            <b-form-input
              v-model="params.email"
              placeholder="......@......"
              id="e-mail"
              required
              :state="validMail(params.email)"
            ></b-form-input>
          </b-col>
          <b-col col cols="12" class="my-1">
            <label for="comment">Комментарий</label>
            <b-form-textarea
              id="comment"
              v-model="params.comment"
              :maxlength="4000"
              placeholder="Комментарий"
              rows="4"
            ></b-form-textarea>
          </b-col>
          <b-col>
            <b-input-group class="mt-2 mb-2 w-100">
          <b-form-file placeholder="файл не выбран" id="filedata" :class="{fileadd:params.filedata}" ref="file" @change="handleFileUpload"></b-form-file>
          <b-button variant="danger" @click="resetFile()" title="удалить документ" v-if="params.filedata">
          <b-icon icon="x"></b-icon>
        </b-button>
        </b-input-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <b-button class="mt-3" @click="sendMail()">Отправить</b-button>
  </div>
</template>

<script>
import Authentication from "@/components/pages/Authentication";
import LoaderSend from "@/components/components/LoaderSend";
export default {
  data() {
    return {
      load:false,
      error_message: "",
      success_message: "",
      params: {
        firstname: null,
        lastname: null,
        patronimic: null,
        phone: null,
        email: null,
        comment: null,
        filedata: null,
        type:this.type
      },
    };
  },
  components:{
      'loader':LoaderSend
  },
  props: ["type"],
  methods: {
    validform() {
      if (this.params.firstname == null) {
        this.params.firstname = "";
      }
      if (this.params.lastname == null) {
        this.params.lastname = "";
      }
      if (this.params.patronimic == null) {
        this.params.patronimic = "";
      }
      if (this.params.email == null) {
        this.params.email = "";
      }
      if (this.params.phone == null) {
        this.params.phone = "";
      }
      return (
        this.notEmpty(this.params.firstname) &&
        this.notEmpty(this.params.lastname) &&
        this.notEmpty(this.params.patronimic) &&
        this.notEmpty(this.params.email) &&
        this.validPhone(this.params.phone)&&
        this.validMail(this.params.email)
      );
    },
    async sendMail() {
      this.load=true;
      if (this.validform()) {
        let { data } = await Authentication.sendRequestNotAuth(
          this,
          "/api/v1/sendMail",
          "post",
          this.params
        );
        if (data.success) {
          this.success_message = "Ваше письмо успешно отправлено";
          this.$bvModal.show("mail-send-valid");
          this.$bvModal.hide("mail-form");
          this.params={
            firstname: null,
            lastname: null,
            patronimic: null,
            phone: null,
            email: null,
            comment: null,
            filedata: null,
            type:this.type
            }
            this.$refs['file'].reset()
        } else {
          this.error_message = "Ошибка при отправке, проверте, размер файла не должен превышать 50МБ";
          this.$bvModal.show("mail-send-not-valid");
        }
      } else {
        this.error_message =
          "Неверно заполнены поля, проверте правильность заполнения";
        this.$bvModal.show("mail-send-not-valid");
      }
      this.load=false;
    },
    notEmpty(val) {
      return val == null ? null : val.length > 0 ? true : false;
    },
    validPhone(val) {
      return val == null ? null : val.length == 18;
    },
    validMail(val) {
      return val == null ? null : (val.indexOf('@') > -1);
    },
    resetFile(){
        this.$refs['file'].reset()
        this.params.filedata =null
    },
    handleFileUpload(event){
        if(event.target.files.length>0){
            this.params.filedata = event.target.files[0];
        }else{
            this.params.filedata =''
        }
        
    }
  },
};
</script>

<style lang="scss">
.form-control{
  border-radius: 0;
}
.fileadd .custom-file-label::after{
    content:'заменить файл' !important;    
}
</style>